import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

const CircularProgressWithLabel = ({ value }) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" value={value} thickness={9} sx={{ borderRadius: '4px' }} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" component="div" color="text.secondary">
          {`${Math.round(value)}%`}
        </Typography>
      </Box>
    </Box>
  );
};

CircularProgressWithLabel.propTypes = {
  value: PropTypes.number.isRequired,
};

const ProgressPercentageIndicator = ({ totalMaterials, sentMaterials }) => {
  const [percentage, setPercentage] = useState(0);

  // Рассчитываем процентное соотношение при любом изменении значений
  useEffect(() => {
    if (totalMaterials > 0) {
      const calculatedPercentage = (sentMaterials / totalMaterials) * 100;
      setPercentage(calculatedPercentage);
    }
  }, [totalMaterials, sentMaterials]);

  return <CircularProgressWithLabel value={percentage} />;
};

ProgressPercentageIndicator.propTypes = {
  totalMaterials: PropTypes.number.isRequired,
  sentMaterials: PropTypes.number.isRequired,
};

export default ProgressPercentageIndicator;
